module.exports = __webpack_public_path__ + "static/media/frames_Q9.f1b53016.png";